'use client';

import { Divider, Padding, Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';
import type { Platform } from '../constants/platforms';
import { PlatformForm } from './PlatformForm';

interface Props {
  showSecondPlatform: boolean;
  platform?: Platform;
  url: string;
  onAddSecondPlatform: () => void;
  onRemoveSecondPlatform: () => void;
  onPlatformSelect: (platform: Platform) => void;
  onUrlChange: (url: string) => void;
  onUrlClear: () => void;
  className?: string;
  isDropdownOpen?: boolean;
  onDropdownOpenChange?: (open: boolean) => void;
  isDuplicated?: boolean;
  urlValidationError?: string | null;
}

export const SecondPlatformSection = ({
  showSecondPlatform,
  platform,
  url,
  onAddSecondPlatform,
  onRemoveSecondPlatform,
  onPlatformSelect,
  onUrlChange,
  onUrlClear,
  className,
  isDropdownOpen,
  onDropdownOpenChange,
  isDuplicated = false,
  urlValidationError,
}: Props) => (
  <div className={twMerge('', className)}>
    <Padding y="4">
      <Divider variant="line" />
    </Padding>

    {!showSecondPlatform ? (
      <div className="w-full py-2 text-center">
        <Typography
          variant="body13pxMed"
          onClick={onAddSecondPlatform}
          colorScheme="black"
          className="underline cursor-pointer"
        >
          다른 플랫폼 추가하기
        </Typography>
      </div>
    ) : (
      <PlatformForm
        platform={platform}
        url={url}
        onPlatformSelect={onPlatformSelect}
        onUrlChange={onUrlChange}
        onUrlClear={onUrlClear}
        title="두 번째로 팔로워 수가 많은 플랫폼은 무엇인가요?"
        showRemoveButton
        onRemove={onRemoveSecondPlatform}
        isDropdownOpen={isDropdownOpen}
        onDropdownOpenChange={onDropdownOpenChange}
        isDuplicated={isDuplicated}
        urlValidationError={urlValidationError}
      />
    )}
  </div>
);
